import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row gap-4 items-stretch" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = {
  key: 0,
  class: "w-full lg:w-72 flex-none"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-center gap-2"
}
const _hoisted_6 = {
  key: 1,
  class: "flex items-center justify-center gap-2"
}
const _hoisted_7 = { class: "mt-4 flex items-start gap-3 rounded-lg border border-orange-300 bg-amber-50 p-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-orange-700" }, "ATENÇÃO!"),
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-sm text-gray-800" }, " NÃO É PERMITIDA A ENTRADA DE ACOMPANHANTES NA EMPRESA. ")
], -1)

import store from "@/store";
import { getThemeColor } from "@/branding";
import { computed, inject } from "vue";
import CalendarioInput from "./CalendarioInput.vue";
import HorariosDisponiveis from "./HorariosDisponiveis.vue";
import { FormValidatedValuesKey } from "../../types/inject";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarioSelector',
  setup(__props) {

const theme = getThemeColor();

const values = inject(FormValidatedValuesKey, {});

const usaJanelas = computed(
  () => !!store.state.setores_usa_janelas[String(values.setor ?? "")]
);

const isSavingAgendamento = computed(() => store.state.isSavingAgendamento);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CalendarioInput, { name: "data" })
      ]),
      (_unref(usaJanelas))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(HorariosDisponiveis)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_t_button, {
      type: "submit",
      disabled: _unref(isSavingAgendamento),
      class: _normalizeClass(["w-full mt-4 py-3 text-lg text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-4 disabled:opacity-70 disabled:cursor-not-allowed", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900 focus:ring-${_unref(theme)}-300`])
    }, {
      default: _withCtx(() => [
        (!_unref(isSavingAgendamento))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, { icon: "check" }),
              _createTextVNode(" Finalizar agendamento ")
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, {
                icon: "sync-alt",
                spin: ""
              }),
              _createTextVNode(" Enviando... ")
            ]))
      ]),
      _: 1
    }, 8, ["disabled", "class"]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_font_awesome_icon, {
        icon: "exclamation-triangle",
        class: "mt-0.5 text-xl text-orange-500"
      }),
      _hoisted_8
    ])
  ]))
}
}

})